var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageQuestionSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message-question-square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.16667 7.33538C9.32818 6.87625 9.64698 6.48909 10.0666 6.24248C10.4862 5.99587 10.9796 5.90572 11.4593 5.988C11.939 6.07029 12.3741 6.31969 12.6875 6.69204C13.001 7.06439 13.1725 7.53566 13.1718 8.02237C13.1718 9.39635 11.1108 10.0833 11.1108 10.0833M11.1374 12.8333H11.1466M6.41667 16.5V18.6409C6.41667 19.1293 6.41667 19.3735 6.51679 19.499C6.60387 19.6081 6.73591 19.6715 6.87549 19.6714C7.03599 19.6712 7.2267 19.5186 7.60811 19.2135L9.79478 17.4642C10.2415 17.1068 10.4648 16.9281 10.7135 16.8011C10.9342 16.6884 11.1691 16.606 11.4118 16.5561C11.6854 16.5 11.9714 16.5 12.5434 16.5H14.85C16.3901 16.5 17.1602 16.5 17.7485 16.2003C18.2659 15.9366 18.6866 15.5159 18.9503 14.9985C19.25 14.4102 19.25 13.6401 19.25 12.1V7.15C19.25 5.60986 19.25 4.83978 18.9503 4.25153C18.6866 3.73408 18.2659 3.31338 17.7485 3.04973C17.1602 2.75 16.3901 2.75 14.85 2.75H7.15C5.60986 2.75 4.83978 2.75 4.25153 3.04973C3.73408 3.31338 3.31338 3.73408 3.04973 4.25153C2.75 4.83978 2.75 5.60986 2.75 7.15V12.8333C2.75 13.6858 2.75 14.112 2.8437 14.4618C3.09799 15.4108 3.83924 16.152 4.78825 16.4063C5.13796 16.5 5.56419 16.5 6.41667 16.5Z",
    stroke: "#FFE600",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageQuestionSquare);
export default __webpack_public_path__ + "static/media/message_question_square.f56f87e94181d906cce7027183cd5455.svg";
export { ForwardRef as ReactComponent };